import { applyMiddleware, createStore } from 'redux';
import { Reducers } from '../reducers';
import { composeWithDevTools } from 'redux-devtools-extension';

// middlewares
import thunk from 'redux-thunk';
//import logger from 'redux-logger';

function getMiddlewares(){
  return applyMiddleware(thunk);
}

export default createStore(Reducers, composeWithDevTools(getMiddlewares()));